import { DatePicker } from "antd";
import type { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import sessionApi from "../../api/sessionApi";
import { STATUS } from "../../constant";
import toast from "react-hot-toast";

interface CreateSessionPopupProps {
    onClose: () => void;
    open: boolean;
    classId?: string;
    onSuccess: () => void;
}

function CreateSessionPopup(props: CreateSessionPopupProps) {
    const { open, onClose, classId, onSuccess } = props;
    const [show, setShow] = useState(open);
    const [error, setError] = useState("");
    const [nameSession, setNameSession] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [startTime, setStartTime] = useState<Dayjs | null>(null);
    const [endTime, setEndTime] = useState<Dayjs | null>(null);

    useEffect(() => {
        setShow(open);
    }, [open]);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setShow(false);
            setTimeout(onClose, 300);
        }
    };

    if (!open) return null; // tránh render khi ẩn hoàn toàn
    const resetForm = () => {
        setNameSession("");
        setDescription("");
        setStartTime(null);
        setEndTime(null);
        setError("");
    }
    const handleSubmit = async () => {
        if (!nameSession) {
            setError("❌ Vui lòng nhập tên buổi học");
            return;
        }
        if (!description) {
            setError("❌ Vui lòng nhập mô tả buổi học");
            return;
        }
        if (!startTime) {
            setError("❌ Vui lòng chọn ngày giờ bắt đầu");
            return
        }
        if (!endTime) {
            setError("❌ Vui lòng chọn ngày giờ kết thúc");
            return;
        }
        const data = {
            classId: Number(classId),
            title: nameSession,
            description,
            // startTime: startTime?.format("YYYY-MM-DD HH:mm:ss"),
            // endTime: endTime?.format("YYYY-MM-DD HH:mm:ss"),
            startTime: startTime?.toISOString(),
            endTime: endTime?.toISOString(),
        }
        console.log("Data to submit: ", data);
        const res = await sessionApi.createSession(data);
        if (res.statusCode === STATUS.SUCCESS || res.statusCode === 201) {
            onSuccess();
        } else if (res.statusCode === 403) {
            toast.error("❌ Thời gian bắt đầu hoặc kết thúc không hợp lệ, vui lòng kiểm tra lại!");
        }
        resetForm()
        setShow(false);
        setTimeout(onClose, 300);
    };

    const onStartTimeChange = (startTime: Dayjs | null) => {
        console.log("Selected Start Time: ", startTime);
        setStartTime(startTime);
    };

    const onEndTimeChange = (endTime: Dayjs | null) => {
        console.log("Selected End Time: ", endTime);
        setEndTime(endTime);
    };

    return (
        <>
            <div
                className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
                onClick={handleOverlayClick}
            >
                <div
                    className={`relative w-full lg:w-[600px] lg:h-fit h-[96%] bg-white p-[10px] rounded-box flex items-center flex-col transform transition-all duration-300 ${show ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
                        }`}
                >
                    <h2 className="text-secondary font-bold text-[20px] mt-[20px]">
                        Tạo buổi học mới
                    </h2>
                    <div className="my-[20px] flex flex-col w-[90%] gap-[10px]">
                        <div className="mb-[10px] flex items-center justify-between">
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Tên buổi học *</label>
                                <input name="nameSession" onChange={(e) => setNameSession(e.target.value)} value={nameSession} className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200 pr-10" />
                            </div>
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Mô tả *</label>
                                <input name="description" onChange={(e) => setDescription(e.target.value)} value={description} className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px] focus:border-[#3498db] focus:ring-1 focus:ring-[#3498db] transition-all duration-200 pr-10" />
                            </div>
                        </div>
                        <div className="mb-[10px] flex items-center justify-between">
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Ngày giờ bắt đầu *</label>
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm"
                                    onChange={onStartTimeChange}
                                    value={startTime}
                                    className="w-full rounded-md border-gray-300 text-sm h-[46px]"
                                />
                            </div>
                            <div className="lg:w-[48%]">
                                <label className="font-[600] inline-block mb-[6px]">Ngày giờ kết thúc *</label>
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm"
                                    onChange={onEndTimeChange}
                                    value={endTime}
                                    className="w-full rounded-md border-gray-300 text-sm h-[46px]"
                                />
                            </div>
                        </div>

                        <p className="text-red-500 text-center h-[10px] my-[10px]">{error}</p>
                        <button
                            onClick={handleSubmit}
                            className="bg-secondary opacity-100 text-white py-[10px] px-[20px] rounded-[6px] hover:opacity-90 transition"
                        >
                            Tạo buổi học
                        </button>
                        <button
                            className="absolute top-[10px] right-[10px]"
                            onClick={() => {
                                setShow(false);
                                setTimeout(onClose, 300);
                            }}                        >
                            <i className="fa-solid fa-close text-[22px] text-blue-500"></i>
                        </button>
                    </div>

                </div>
            </div >
        </>
    );
}

export default CreateSessionPopup;
